<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <ClientNav/>
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">
              {{ titleForm }}
              <v-icon v-if="isSaving" class="ml-2" color="white">mdi-loading mdi-spin</v-icon>
            </span>
            <v-spacer></v-spacer>
            <v-chip v-if="isSaving" color="warning" text-color="white" small>
              <v-icon left small>mdi-clock</v-icon>
              Saving...
            </v-chip>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              lazy-validation>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-select
                      v-model="newTask"
                      label="Select Event"
                      :items="taskList"
                      @change="visit()"
                      :rules="requiredField"
                      :disabled="isSaving"
                    ></v-select>
                  </v-col>
                  <template v-if="drsVisit">
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="newProviderType"
                        label="Providers"
                        :items="providers"
                        item-text="Provider.Name"
                        item-value="Provider._id"
                        :rules='requiredField'
                        :disabled="isSaving"
                      >
                        <template v-slot:prepend-item>
                          <v-list-item>
                            <v-list-item-content>
                                                      <v-text-field
                          v-model="search"
                          placeholder="Search"
                          @input="searchProvider"
                          :disabled="isSaving"
                        />
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-select
                        v-model="newVisitType"
                        label="Visit Type"
                        :items="sortedVisitType"
                        item-value="Name"
                        item-text="Name"
                        :rules='requiredField'
                        :disabled="isSaving"
                      ></v-select>
                    </v-col>
                  </template>
                  <v-col cols="12" sm="12" md="4">
                    <v-autocomplete
                      v-model="newStaffAssigned"
                      :items="users"
                      item-text="Name"
                      item-value="_id"
                      label="Staff Assigned"
                      clearable
                      :rules="requiredField"
                      return-object
                      :filter="customFilter"
                      :disabled="isSaving"
                    >
                      <template #selection="{ item }">
                        <v-chip :key="item._id" v-if="item">{{ item.Name }}</v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-select
                      v-model="newProgram"
                      :items="selectedClientPrograms"
                      label="Program"
                      :rules="requiredField"
                      :disabled="isSaving"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Notes"
                      v-model="newNotes"
                      outlined
                      :disabled="isSaving"
                    ></v-textarea>
                  </v-col>
                  <v-row>
                    <template>
                      <v-col cols="12" sm="12" md="6">
                        <v-datetime-picker
                          :label="`${newTask} Start Date and Time`"
                          v-model="newDueStartTime"
                          prepend-icon="mdi-calendar"
                          :disabled="isSaving"
                        ></v-datetime-picker>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-datetime-picker
                          :label="`${newTask} End Date and Time`"
                          v-model="newDueEndTime"
                          prepend-icon="mdi-calendar"
                          :disabled="isSaving"
                        ></v-datetime-picker>
                      </v-col>
                    </template>

                  </v-row>


                  <v-col cols="12" sm="12" md="12">
                    <v-radio-group
                      v-model="newTransportation"
                      label="Is Transportation Required?"
                      :rules="requiredField"
                      row
                      :disabled="isSaving"
                    >
                      <v-radio
                        label="Yes"
                        value="Yes"
                      ></v-radio>
                      <v-radio
                        label="No"
                        value="No"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col v-if="newTransportation === 'Yes'" cols="12" sm="12" md="4">
                    <v-text-field
                      label="Transportation From"
                      v-model="newFrom"
                      :rules="newTransportation === 'Yes' ? requiredField : []"
                      :disabled="isSaving"
                    ></v-text-field>
                  </v-col>
                  <v-col v-if="newTransportation === 'Yes'" cols="12" sm="12" md="4">
                    <v-text-field
                      label="Transportation To"
                      v-model="newTo"
                      :rules="newTransportation === 'Yes' ? requiredField : []"
                      :disabled="isSaving"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      readonly
                      v-model="newDateCreated"
                      label="Date Created"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      label="Created By"
                      v-model="newCreatedBy"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" sm="12" md="2">
                      <v-checkbox
                          v-model="signed"
                          label="Completed By"
                          hint="Sign only after the appointment has been attended and completed"
                          @click="addSignature()"
                      ></v-checkbox>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="4">
                    <v-text-field v-model="newCompletedBy" readonly v-if="signed === true"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              @click="showPrintModal()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="!newEvent"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              class="white--text"
              color="#259647"
              @click="addEvent()"
              v-if="newEvent && !isAuditorRole"
              :loading="isSaving"
              :disabled="isSaving"
            >
              <v-icon left v-if="isSaving">mdi-loading mdi-spin</v-icon>
              {{ isSaving ? 'Saving...' : 'Save' }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateEvent()"
              v-if="!newEvent && !isAuditorRole"
              :loading="isSaving"
              :disabled="isSaving"
            >
              <v-icon left v-if="isSaving">mdi-loading mdi-spin</v-icon>
              {{ isSaving ? 'Updating...' : 'Update' }}
            </v-btn>
            <v-btn color="blue darken-1" text @click="close" :disabled="isSaving">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import {mapActions} from "vuex";

const ClientService = require('../../service/client.service');
import ClientNav from "@/components/ClientNav.vue";

const UnitService = require('../../service/unit.service');
const url = require("../../client_config/config").url;
import Swal from 'sweetalert2';
import { displaySuccess, displayError } from "@/service/notification-message.service";

export default {
  components: {
    ClientNav,
  },
  data() {
    return {
      clientID: this.$route.params.clientID,
      id: this.$route.params.id,
      search: "",
      titleForm: "New Event",
      isSaving: false,
      newTask: "",
      newStaffAssigned: "",
      newNotes: "",
      newTransportation: "",
      newFrom: "",
      newTo: "",
      newDueDate: null,
      newTime: "",
      newDateCreated: new Date(),
      newCreatedBy: localStorage.getItem('Name'),
      newCompletedBy: "",
      eventID: "",
      users: [],
      taskList: [
        "Activity",
        "Appointment",
        "Birthday",
        "Bus",
        "Dr. Visit",
        "Family Visit",
        "Meeting",
        "Menu",
        "Other",
        "Reminder",
        "Transportation",
        "Vocational Rehabilitation",
        "Maintenance",
        "Work"
      ],
      drsVisit: false,
      providers: [],
      signed: '',
      newProviderType: "",
      visitType: [
        "Admitting Physician",
        "Allergist",
        "Appointed Attorney",
        "Attending Physician",
        "Appointed Attorney",
        "Audiologist",
        "Behaviorist",
        "Cardiologist",
        "Care Worker Supervisor",
        "Case Worker",
        "Chiropractor",
        "Counselor/Therapist",
        "Dentist",
        "Dermatologist",
        "Ears, Nose and Throat (ENT)",
        "Emergency Room",
        "Employer",
        "Endocrinologist",
        "Gastroenterologist",
        "Gynecologist",
        "Hospital",
        "Lab",
        "Legal Guardian",
        "Nephrologist",
        "Neurologist",
        "Nurse",
        "Nurse Practitioner",
        "Nutritionist/Dietician",
        "Occupational Therapist",
        "Optometrist/Ophthalmologist",
        "Orthopedic",
        "Parent (Connect Access)",
        "Pharmacy",
        "Phlebotomist",
        "Physical Therapist",
        "Physician or Specialist",
        "Physician Assistant",
        "Podiatrist",
        "Primary Care MD",
        "Psychiatrist",
        "Public Guardian",
        "Radiologist",
        "Sleep Specialist",
        "Support Coordinator",
        "Surgeon",
        "Urologist",
        "Urgent Care",
        "Work Site",
        "Wound Care"
      ],
      newVisitType: "",
      newProgram: '',
      selectedClientPrograms: [],
      userState: localStorage.getItem('userState'),
      requiredField: [v => !!v || 'This is required'],
      clientProviders: [],
      medicalVisit: null,
      msg: false,
      text: "",
      newEvent: false,
      event: {},
      newDueStartTime: null,
      newDueEndTime: null,
    };
  },

  created() {
    this.newEvent = this.$route.query.newEvent === 'true';
  },

  computed: {
    sortedVisitType() {
      return this.visitType.slice().sort();
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  async mounted() {
    await this.getProviders();
    this.setProgram();
    this.getUsers();

    if (!this.newEvent) {
      this.getEvent();
    }

    // Add beforeunload event listener
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },

  beforeDestroy() {
    // Remove beforeunload event listener
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },

  beforeRouteLeave(to, from, next) {
    if (this.isSaving) {
      Swal.fire({
        title: 'Saving in Progress',
        text: 'Please wait while the event is being saved. Do not close this page.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'OK',
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: 'modern-loading-modal',
          title: 'modern-loading-title',
          confirmButton: 'modern-confirm-btn'
        },
        background: 'rgba(255, 255, 255, 0.95)',
        backdrop: 'rgba(0, 0, 0, 0.4)'
      });
      next(false);
    } else {
      next();
    }
  },

  methods: {
    ...mapActions({
      getClientProviders: "clientProviders/getItem",
      addItem: "events/addItem",
    }),


    close() {
      this.clear();
      this.$router.go(-1);
    },

    validate() {
      // First validate the form using Vuetify's built-in validation
      const formValid = this.$refs.form.validate();
      
      // Check basic required fields
      if (!this.newTask) {
        this.showValidationError('Please select an event type');
        return false;
      }
      
      if (!this.newStaffAssigned) {
        this.showValidationError('Please select a staff member');
        return false;
      }
      
      if (!this.newProgram) {
        this.showValidationError('Please select a program');
        return false;
      }
      
      if (!this.newTransportation) {
        this.showValidationError('Please select whether transportation is required');
        return false;
      }
      
      // Additional validation for Dr. Visit specific fields
      if (this.newTask === 'Dr. Visit') {
        if (!this.newProviderType) {
          this.showValidationError('Please select a provider for Dr. Visit');
          return false;
        }
        if (!this.newVisitType) {
          this.showValidationError('Please select a visit type for Dr. Visit');
          return false;
        }
      }

      // Additional validation for transportation fields
      if (this.newTransportation === 'Yes') {
        if (!this.newFrom || !this.newTo) {
          this.showValidationError('Please fill in both transportation "From" and "To" fields');
          return false;
        }
      }
      
      // Validate date/time fields
      if (!this.newDueStartTime) {
        this.showValidationError('Please select event start date and time');
        return false;
      }
      
      if (!this.newDueEndTime) {
        this.showValidationError('Please select event end date and time');
        return false;
      }
      
      // Validate date range
      if (!this.validateDateTimeRange()) {
        return false;
      }
      
      return formValid;
    },

    async getProviders() {
      const response = await this.getClientProviders(this.clientID);
      this.providers = response.data;
      console.log({providers: this.providers});
      this.clientProviders = this.providers;
    },


    getUsers() {
      const companyIds = localStorage.getItem('userCompanies');
      let params = {
        Company: JSON.parse(companyIds),
        page: 1,
        limit: 50
      };

      this.getPaginatedUsers(params);
    },

    getPaginatedUsers(params) {
      let endpoint = `${url}/users/state/${this.userState}`;

      axios.get(endpoint, {params}).then((res) => {
        if (res.data.users.length > 0) {
          this.users = this.users.concat(res.data.users);
        }

        if (res.data.totalUsers > this.users.length) {
          params.page++;
          this.getPaginatedUsers(params);
        }
      });
    },

    visit: function () {
      if (this.newTask === "Dr. Visit") {
        this.drsVisit = true;
      } else {
        this.drsVisit = false;
      }
    },

    async addEvent() {
      if (this.validate()) {
        this.isSaving = true;
        const companyIds = localStorage.getItem('userCompanies')

        // Convert dates to ISO string
        const startDate = new Date(this.newDueStartTime).toISOString();
        const endDate = new Date(this.newDueEndTime).toISOString();

        let req_body = {
          Event: this.newTask,
          Client: this.clientID,
          Program: this.newProgram,
          Staff: this.newStaffAssigned,
          Notes: this.newNotes,
          Transportation: this.newTransportation,
          To: this.newTo,
          From: this.newFrom,
          StartDate: startDate,
          EndDate: endDate,
          CreatedDate: new Date(this.newDateCreated).toISOString(),
          CreatedBy: this.newCreatedBy,
          Signature: this.newCompletedBy,
          ReviewingProvider: this.newProviderType,
          VisitType: this.newVisitType,
          UpcomingEvent: true,
          UrlNotification: this.$router.history.current.path,
          Company: JSON.parse(companyIds)
        };

        try {
          this.showLoadingAddDialog();
          const response = await this.addItem(req_body);
          Swal.close(); // Close the loading dialog
          if (response.status === 500) {
            this.isSaving = false;
            this.showErrorAddDialog();
            return;
          }
          this.eventID = response._id;
          this.showSuccessAddDialog();
          this.isSaving = false;
          this.close();
        } catch (error) {
          console.error('Error adding item:', error);
          Swal.close(); // Close the loading dialog
          this.isSaving = false;
          this.showErrorAddDialog();
          // Don't close the form on error - keep the data intact
        }
      }

    },

    addSignature() {
      if (!this.signed) {
        return this.newCompletedBy = ''
      }
      this.newCompletedBy = this.newCreatedBy + " - " + new Date();
      this.signed = true;
    },

    async onViewItem(item) {
      console.log({item});

      if (item.Program) {
        UnitService.getById(item.Program).then(response => {
          const {unit} = response.data;
          this.newProgram = unit.Name;
        });
      }

      this.titleForm = "Viewing " + item.Event;
      this.newTask = this.taskList.includes(item.Event) ? item.Event : this.taskList.push(item.Event);
      this.newStaffAssigned = item.Staff;
      this.newNotes = item.MedicalVisit?.Notes || item.Notes;
      this.newTransportation = item.Transportation;
      this.newFrom = item.From;
      this.newTo = item.To;
      this.newDueStartTime = new Date(item.StartDate);
      this.newDueEndTime = new Date(item.EndDate);



      this.newDateCreated = new Date(item.CreatedDate);
      this.newCreatedBy = item.CreatedBy;
      this.newCompletedBy = item.Signature;
      this.eventID = item._id;

      if (item.Event === 'Dr. Visit') {
        this.drsVisit = true;
        if (item.MedicalVisit) {
          this.newVisitType = item.MedicalVisit.VisitType || '';
          this.medicalVisit = item.MedicalVisit
          const itemProvider = this.providers.find(provider => provider.Provider._id.toString() === item.MedicalVisit.ReviewingProvider._id.toString()) || '';
          this.newProviderType = itemProvider.Provider._id || '';
        }
      }

      if (item.Signature !== "" && item.Signature !== undefined) {
        this.signed = true;
      }
      this.newTask = item.Event;
    },

    getEvent() {
      axios.get(`${url}/calendar/${this.id}`).then(response => {
        this.event = response.data;
        console.log({event: this.event});
        this.getProviders();
        this.onViewItem(this.event);
      }).catch(error => {
        console.error('Error fetching calendar event:', error);
      });
    },

    updateEvent() {
      if (this.validate()) {
        this.isSaving = true;

      // Convert dates to ISO string
      const startDate = new Date(this.newDueStartTime).toISOString();
      const endDate = new Date(this.newDueEndTime).toISOString();

      const req_body = {
        Event: this.newTask,
        Client: this.clientID,
        Program: this.newProgram,
        Staff: this.newStaffAssigned,
        Notes: this.newNotes,
        Transportation: this.newTransportation,
        To: this.newTo,
        From: this.newFrom,
        StartDate: startDate,
        EndDate: endDate,
        CreatedDate: new Date(this.newDateCreated).toISOString(),
        CreatedBy: this.newCreatedBy,
        Signature: this.newCompletedBy,
        UpcomingEvent: true,
        ReviewingProvider: this.newProviderType,
        VisitType: this.newVisitType,
        UrlNotification: this.$router.history.current.path,
      };

      if (this.newTask === 'Dr. Visit') {
        req_body.MedicalVisit = this.medicalVisit;
      }

      this.showLoadingUpdateDialog();

      axios.put(`${url}/calendar/${this.id}`, req_body)
        .then((response) => {
          console.log({response});
          Swal.close();
          this.isSaving = false;
          this.showSuccessUpdateDialog();
          this.close();
        })
        .catch((error) => {
          console.error('Error updating calendar event:', error);
          Swal.close();
          this.isSaving = false;
          this.showErrorUpdateDialog();
        });
      }
    },

    setProgram() {
      ClientService.getById(this.clientID).then(response => {
        const client = response.data.client;

        if (client && client[0].Program && client[0].Program.length) {
          this.selectedClientPrograms = client[0].Program;
          this.newProgram = client[0].Program;
        }
      });
    },

    clear() {
      this.newTask = "";
      this.newStaffAssigned = "";
      this.newNotes = "";
      this.newTransportation = "";
      this.newDueDate = moment().format('YYYY-MM-DD HH:mm');
      this.newDueStartTime = null;
      this.newDueEndTime = null;
      this.newFrom = "";
      this.newTo = "";
      this.newTime = "";
      this.newCompletedBy = this.newCreatedBy + " - " + new Date();
      this.newProviderType = "";
      this.newVisitType = "";
      this.newProgram = "";
      this.newDateCreated = moment().toLocaleString();
      this.newCreatedBy = localStorage.getItem('Name');

      // Reset form validation state
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    customFilter(item, queryText) {
      const searchText = queryText.toLowerCase();
      const itemName = item.Name.toLowerCase();
      return itemName.indexOf(searchText) > -1;
    },

    showPrintModal() {

      let id = this.eventID;
      let downloadUrl = `${url}/calendar/download?id=${id}`;

      // Show the "Print in progress" modal
      Swal.fire({
        title: 'Print in Progress',
        text: 'Please wait while the PDF is being generated and processed...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Make a request to the backend API to generate the PDF
      fetch(downloadUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          const printWindow = window.open(blobUrl);

          printWindow.onload = function () {
            Swal.close();

            printWindow.print();

            URL.revokeObjectURL(blobUrl);
          };
        })
        .catch((error) => {
          console.error('Error generating or printing the PDF:', error);
          Swal.fire('Error', 'Failed to generate or print the PDF', 'error');
        });
    },

    searchProvider() {
      if (!this.search) {
        this.providers = this.clientProviders
      }

      this.providers = this.clientProviders.filter((item) => {
        return item.Provider.Name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
      });
    },

    showLoadingAddDialog() {
      Swal.fire({
        title: 'Creating Event',
        text: 'Please wait while we save your event...',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: 'modern-loading-modal',
          title: 'modern-loading-title'
        },
        background: 'rgba(255, 255, 255, 0.95)',
        backdrop: 'rgba(0, 0, 0, 0.4)',
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },

    showLoadingUpdateDialog() {
      Swal.fire({
        title: 'Updating Event',
        text: 'Please wait while we update your event...',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          popup: 'modern-loading-modal',
          title: 'modern-loading-title'
        },
        background: 'rgba(255, 255, 255, 0.95)',
        backdrop: 'rgba(0, 0, 0, 0.4)',
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },

    showSuccessAddDialog() {
      displaySuccess('A new upcoming event has been added successfully.');
    },

    showSuccessUpdateDialog() {
      displaySuccess('An upcoming event has been updated successfully.');
    },

    showErrorAddDialog() {
      Swal.fire({
        icon: 'error',
        title: 'Save Failed',
        text: 'An error occurred while creating the event. Your data has been preserved. Please check your connection and try again.',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Try Again',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: 'modern-loading-modal',
          title: 'modern-loading-title',
          confirmButton: 'modern-confirm-btn',
          cancelButton: 'modern-cancel-btn'
        },
        background: 'rgba(255, 255, 255, 0.95)',
        backdrop: 'rgba(0, 0, 0, 0.4)'
      }).then((result) => {
        if (result.isConfirmed) {
          // Retry saving the event
          this.addEvent();
        }
      });
    },

    validateDateTimeRange() {
      if (this.newDueStartTime && this.newDueEndTime) {
        const startDate = new Date(this.newDueStartTime);
        const endDate = new Date(this.newDueEndTime);

        if (endDate <= startDate) {
          this.showValidationError('End date/time must be after start date/time');
          return false;
        }
      }
      return true;
    },

    showValidationError(message) {
      displayError(message);
    },

    handleBeforeUnload(event) {
      if (this.isSaving) {
        event.preventDefault();
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return 'You have unsaved changes. Are you sure you want to leave?';
      }
    },

    showErrorUpdateDialog() {
      Swal.fire({
        icon: 'error',
        title: 'Update Failed',
        text: 'An error occurred while updating the event. Your data has been preserved. Please check your connection and try again.',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Try Again',
        cancelButtonText: 'Cancel',
        customClass: {
          popup: 'modern-loading-modal',
          title: 'modern-loading-title',
          confirmButton: 'modern-confirm-btn',
          cancelButton: 'modern-cancel-btn'
        },
        background: 'rgba(255, 255, 255, 0.95)',
        backdrop: 'rgba(0, 0, 0, 0.4)'
      }).then((result) => {
        if (result.isConfirmed) {
          // Retry updating the event
          this.updateEvent();
        }
      });
    }
  },
};
</script>

<style scoped>
/* Modern Loading Modal Styles */
:deep(.modern-loading-modal) {
  border-radius: 16px !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  max-width: 400px !important;
  padding: 2rem !important;
}

:deep(.modern-loading-title) {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: #2b3990 !important;
  margin-bottom: 1.5rem !important;
  text-align: center !important;
}

:deep(.modern-loading-container) {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  padding: 1rem 0;
}

/* Style SweetAlert2's built-in loading spinner */
:deep(.swal2-loading) {
  border: 4px solid #f3f3f3 !important;
  border-top: 4px solid #2b3990 !important;
  border-radius: 50% !important;
  width: 48px !important;
  height: 48px !important;
  animation: modern-spin 1s linear infinite !important;
}

:deep(.swal2-html-container) {
  font-size: 1rem !important;
  color: #666 !important;
  text-align: center !important;
  margin-top: 1rem !important;
  line-height: 1.5 !important;
}

@keyframes modern-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Modern backdrop */
:deep(.swal2-backdrop-show) {
  backdrop-filter: blur(4px) !important;
}

/* Modern confirm button */
:deep(.modern-confirm-btn) {
  background: #2b3990 !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 12px rgba(43, 57, 144, 0.3) !important;
  transition: all 0.2s ease !important;
}

:deep(.modern-confirm-btn:hover) {
  background: #1e2a6b !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(43, 57, 144, 0.4) !important;
}

/* Modern cancel button */
:deep(.modern-cancel-btn) {
  background: #6c757d !important;
  border-radius: 8px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3) !important;
  transition: all 0.2s ease !important;
}

:deep(.modern-cancel-btn:hover) {
  background: #5a6268 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4) !important;
}

/* Responsive design */
@media (max-width: 768px) {
  :deep(.modern-loading-modal) {
    margin: 1rem !important;
    padding: 1.5rem !important;
  }

  :deep(.modern-loading-title) {
    font-size: 1.25rem !important;
  }

  :deep(.modern-spinner) {
    width: 40px;
    height: 40px;
  }
}
</style>
